import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";

let activeLockCount = 0;
let lockedScrollY = 0;
let previousBodyStyles = null;
let previousHtmlStyles = null;
let fixedBodyLockActive = false;

const shouldUseFixedBodyLock = () => !(
  Capacitor.isNativePlatform()
  && Capacitor.getPlatform() === "android"
);

const snapshotStyles = (element, properties) =>
  properties.reduce((snapshot, property) => {
    snapshot[property] = element.style[property];
    return snapshot;
  }, {});

const restoreStyles = (element, snapshot) => {
  if (!snapshot) return;
  Object.entries(snapshot).forEach(([property, value]) => {
    element.style[property] = value;
  });
};

const lockPageScroll = () => {
  if (typeof document === "undefined" || typeof window === "undefined") return;

  activeLockCount += 1;
  if (activeLockCount > 1) return;

  const { body, documentElement } = document;
  lockedScrollY = window.scrollY || documentElement.scrollTop || body.scrollTop || 0;
  previousBodyStyles = snapshotStyles(body, ["overflow", "position", "top", "left", "right", "width"]);
  previousHtmlStyles = snapshotStyles(documentElement, ["overflow", "overscrollBehavior"]);
  fixedBodyLockActive = shouldUseFixedBodyLock();

  documentElement.classList.add("appModalScrollLock");
  body.classList.add("appModalScrollLock");
  documentElement.style.overflow = "hidden";
  documentElement.style.overscrollBehavior = "none";
  body.style.overflow = "hidden";
  // Android WebView, tam ekran modal animasyonu başlarken body'yi fixed
  // katmana taşırsa ana içeriği bir kareliğine yeniden compositing yapıyor.
  // WebView'de html/body overflow kilidi tek başına yeterli; iOS ve web için
  // mevcut scroll-konumu koruyan fixed-body davranışı aynen devam eder.
  if (fixedBodyLockActive) {
    body.style.position = "fixed";
    body.style.top = `-${lockedScrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
  }
};

const unlockPageScroll = () => {
  if (typeof document === "undefined" || typeof window === "undefined") return;
  if (activeLockCount === 0) return;

  activeLockCount -= 1;
  if (activeLockCount > 0) return;

  const { body, documentElement } = document;
  documentElement.classList.remove("appModalScrollLock");
  body.classList.remove("appModalScrollLock");
  restoreStyles(documentElement, previousHtmlStyles);
  restoreStyles(body, previousBodyStyles);
  previousHtmlStyles = null;
  previousBodyStyles = null;
  if (fixedBodyLockActive) window.scrollTo(0, lockedScrollY);
  fixedBodyLockActive = false;
};

export default function useBodyScrollLock(active = true) {
  useEffect(() => {
    if (!active) return undefined;
    lockPageScroll();
    return unlockPageScroll;
  }, [active]);
}
